/**
 * FormCard — DS Organism
 * GlassCard + CardHeader + form layout + footer actions
 */

import { GlassCard } from '../GlassCard/GlassCard';
import { CardHeader } from '../../molecules';
import styles from './FormCard.module.css';

interface FormCardProps {
  title: string;
  subtitle?: string;
  count?: number;
  onSubmit?: (e: React.FormEvent) => void;
  footer?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function FormCard({ title, subtitle, count, onSubmit, footer, children, className = '' }: FormCardProps) {
  return (
    <GlassCard className={className}>
      <CardHeader title={title} subtitle={subtitle} count={count} />
      <div className={styles.sep} />
      <form onSubmit={onSubmit} noValidate>
        <div className={styles.fields}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </form>
    </GlassCard>
  );
}
